import { createStore } from '../_core/createStore';
import { signUpStore } from './signUpStore';

const useSignUpStore = createStore({
  creator: signUpStore,
  id: 'signUp',
  middlewares: {
    devtools: true,
    persist: true,
  },
});

export default useSignUpStore;
